import React from 'react';
import PropTypes from 'prop-types';
import BaseTimeAgo from 'react-timeago';

function formatter(value, unit, suffix) {
  // We don't care about the under-minute time resolution
  if (unit === 'second') {
    return 'Less than a minute ago';
  }

  // This is the default formatter take from react-timeago:
  if (value !== 1) {
    unit += 's'; // eslint-disable-line no-param-reassign, no-param-reassign
  }
  return `${value} ${unit} ${suffix}`;
}

const TimeAgo = ({ date, ...props }) => (
  <BaseTimeAgo
    date={date}
    minPeriod={60}
    formatter={formatter}
    {...props}
  />
);
TimeAgo.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
};

export default TimeAgo;
